

















import Vue from 'vue';
import axios from 'axios';
import ReportControls, { ReportSpecByWeek, Account, ReportSpec, DateType } from '@/components/ReportControls.vue';
import ReportTable from '@/components/ReportTable.vue';
import XLSX from 'xlsx';
import {DateTime} from "luxon";

interface DateRangeOptions {
    [year: number]: number[];
}

export default Vue.extend({
    name: 'CustomerService',
    components: {ReportControls, ReportTable},
    data() {
        const now = new Date();
        return {
            dateOptions: {} as DateRangeOptions,
            spec: {} as ReportSpec,
            loading: true,
            data: [] as Array<[string, ...number[]]>,
            headers: [],
        };
    },
    computed: {
        dataUrl(): string {
            const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
            if (this.spec.dateStyle === "calendar") {
              const {depot, from, to} = this.spec;
              return `${BASE_URL}/reports/customer-service/${depot}/${DateTime.fromJSDate(from).toISODate()}/${DateTime.fromJSDate(to).toISODate()}/`;
            } else {
              const {depot, from, to} = this.spec;
              return `${BASE_URL}/reports/customer-service/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
            }

        },
    },
    watch: {
        async spec() {
            this.loading = true;
            const response = await axios.get(this.dataUrl, {
                params: {
                    account_codes: this.spec.accountCodes.flatMap((a: Account) => a.codes),
                },
            });
            this.headers = response.data.headers;
            this.data = response.data.results;
            this.loading = false;
        },
    },
    methods: {
        download() {
            const wb = XLSX.utils.book_new();
            const sheet = XLSX.utils.table_to_sheet((this.$refs.table as Vue).$el);
            XLSX.utils.book_append_sheet(wb, sheet, 'Customer Service Mix');
            if (this.spec.dateStyle === "calendar") {
              const { depot, from, to } = this.spec;
              XLSX.writeFile(wb, `Customer Service Mix for Depot ${depot} - ${from} to ${to}.xlsx`);
            } else {
              const {depot, from, to} = this.spec;
              XLSX.writeFile(wb, `Customer Service Mix for Depot ${depot} - ${from.year}${from.week} to ${to.year}${to.week}.xlsx`);
            }
        },
    },
});
